import '../../../../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../../node_modules/lit-html/lit-html.js';
import '../../../../../node_modules/lit-element/lit-element.js';
import { classMap as o } from '../../../../../node_modules/lit-html/directives/class-map.js';
import { ifDefined as l } from '../../../../../node_modules/lit-html/directives/if-defined.js';

/* eslint-disable no-param-reassign */
const NO_DATA_ERROR_MSG = 'No categories were found, check the integrity of data supplied to component';
const renderNativeSelects = (ctx) => {
    if (ctx.categories === null) {
        // eslint-disable-next-line no-console
        console.warn(NO_DATA_ERROR_MSG);
        return null;
    }
    return ctx.categories.map((el) => {
        const subCategories = el.SubSubCategories.map((subCat) => {
            var _a;
            return x `<li class="pim-subnav__subcategory-item subcategory-item" data-category="${el.Title}"><label class="checkbox-container">${subCat.Title} <input type="checkbox" name="${subCat.Title}" .value="${subCat.CategoryUrl}" .checked="${(_a = subCat.IsActive) !== null && _a !== void 0 ? _a : false}" @change="${() => ctx.onCategoryClick()}"> <span class="checkmark"></span></label></li>`;
        });
        /* eslint-disable lit-a11y/click-events-have-key-events */
        return x `<div class="pim-subnav__subcategory-wrapper ${o({ active: el.IsActive })}"><ul><li class="pim-subnav__subcategory-label" aria-label="select subcategory" name="${el.Title}" @click="${() => ctx.toggleCategoryByName(el.Title)}" data-category="${el.Title}">${el.Title}</li>${subCategories}</ul></div>`;
        /* eslint-enable lit-a11y/click-events-have-key-events */
    });
};
const renderDesktopNav = (ctx) => x `<div class="desktop-nav">${renderNativeSelects(ctx)}</div>`;
const renderMobileNav = (ctx) => x `<cvt-accordion><accordion-item slot="accordion-item" title="${l(ctx.mobileMenuTitle || "Product Filters")}"><div slot="accordion-content"><div class="pim-subnav">${renderNativeSelects(ctx)}</div></div></accordion-item></cvt-accordion>`;

export { renderDesktopNav, renderMobileNav, renderNativeSelects };
